import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export interface PaymentState {
  isProcessing: boolean
  paymentUrl: string | null
  merchantTransactionId: string | null
  transactionId: string | null
  status: "idle" | "pending" | "success" | "failed" | "cancelled"
  error: string | null
  amount: number
  orderId: string | null
}

const initialState: PaymentState = {
  isProcessing: false,
  paymentUrl: null,
  merchantTransactionId: null,
  transactionId: null,
  status: "idle",
  error: null,
  amount: 0,
  orderId: null,
}

const phonepeSlice = createSlice({
  name: "phonepe",
  initialState,
  reducers: {
    initiatePayment: (state, action: PayloadAction<{ amount: number; orderId: string }>) => {
      state.isProcessing = true
      state.status = "pending"
      state.amount = action.payload.amount
      state.orderId = action.payload.orderId
      state.error = null
    },
    paymentInitiated: (
      state,
      action: PayloadAction<{ paymentUrl: string; merchantTransactionId: string; transactionId: string }>,
    ) => {
      state.paymentUrl = action.payload.paymentUrl
      state.merchantTransactionId = action.payload.merchantTransactionId
      state.transactionId = action.payload.transactionId
      state.isProcessing = false
    },
    paymentSuccess: (state, action: PayloadAction<{ transactionId: string; merchantTransactionId: string }>) => {
      state.status = "success"
      state.transactionId = action.payload.transactionId
      state.merchantTransactionId = action.payload.merchantTransactionId
      state.isProcessing = false
      state.error = null
    },
    paymentFailed: (state, action: PayloadAction<{ error: string }>) => {
      state.status = "failed"
      state.error = action.payload.error
      state.isProcessing = false
    },
    paymentCancelled: (state) => {
      state.status = "cancelled"
      state.isProcessing = false
    },
    resetPayment: (state) => {
      return initialState
    },
    setPaymentStatus: (state, action: PayloadAction<PaymentState["status"]>) => {
      state.status = action.payload
    },
  },
})

export const {
  initiatePayment,
  paymentInitiated,
  paymentSuccess,
  paymentFailed,
  paymentCancelled,
  resetPayment,
  setPaymentStatus,
} = phonepeSlice.actions

export default phonepeSlice.reducer
